import { createSvgIcon } from "@mui/material";

export default createSvgIcon(
  <svg
    width="24"
    height="19"
    viewBox="0 0 24 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.75 3.46252C3.45 4.51669 1.91667 6.81669 1.91667 9.50002C1.91667 12.1834 3.45 14.4834 5.75 15.5375V17.6459C2.39583 16.4 0 13.2375 0 9.50002C0 5.76252 2.39583 2.60002 5.75 1.35419V3.46252Z"
      fill="#222A5C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.375 2.575C10.5222 2.575 7.45 5.64722 7.45 9.5C7.45 13.3528 10.5222 16.425 14.375 16.425C18.2278 16.425 21.3 13.3528 21.3 9.5C21.3 5.64722 18.2278 2.575 14.375 2.575ZM14.375 0.875C9.58333 0.875 5.75 4.70833 5.75 9.5C5.75 14.2917 9.58333 18.125 14.375 18.125C19.1667 18.125 23 14.2917 23 9.5C23 4.70833 19.1667 0.875 14.375 0.875Z"
      fill="#222A5C"
    />
    <path
      d="M15.3335 10.4583H19.1668V8.54165H15.3335V4.70831H13.4168V8.54165H9.5835V10.4583H13.4168V14.2916H15.3335V10.4583Z"
      fill="#222A5C"
    />
  </svg>,
  "Budgets"
);
